<template>
    <div>
        <a :href="urlPath">
            <LazyImage  v-if="imgPath" :imageUrl="imgPath" :classes="['image-container--banner']" :alt="urlPath" />
        </a>
    </div>

</template>

<script>
  import LazyImage from "./LazyImage";
  export default {
    name: "Banner",
    props: {
      imgPath: String,
      urlPath: String,
    },
    components: {
      LazyImage
    }
  }
</script>

<style>
    .image-container--banner img {
        height: auto !important;
    }

</style>
